// Version : 0.0.1
// Author : VAIBAV
// MODIFIED DATA : 23-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import CollectionFormatReportTypes from './collection-format-report.types';
import { getCollectionFormatReportDetails } from './collection-format-report.service';
import {
	fetchCollectionFormatReportSuccess,
	fetchCollectionFormatReportFailure,
	fetchCollectionFormatReportResponseResetChanged,
} from './collection-format-report.action';
import { encryptData } from '../../_common/enode-decode';

/* ********************START FETCH CollectionFormat DETAILS ********************** */
export function* fetchCollectionFormatReportDetails({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			reportDate,
			branchID,
			groupID,
			centerID,
			funderID,
			memberID,
			searchByLoanModal,
			limit,
		} = payload;
		const key = 'GetCollectionFormatReportDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ReportDate: reportDate,
			BranchID: branchID,
			GroupID: groupID,
			CenterID: centerID,
			FunderID: funderID,
			MemberID: memberID,
			SearchByLoanModal: searchByLoanModal,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getCollectionFormatReportDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchCollectionFormatReportFailure(responseData.data));
		} else {
			yield put(fetchCollectionFormatReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCollectionFormatReportFailure(error));
	}
}
export function* resetCollectionFormatReportResponse() {
	yield put(fetchCollectionFormatReportResponseResetChanged());
}

export function* onFetchCollectionFormatReportDetails() {
	yield takeLatest(
		CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_START,
		fetchCollectionFormatReportDetails,
	);
}

export function* onFetchCollectionFormatReportResponseReset() {
	yield takeLatest(
		CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_RESET_START,
		resetCollectionFormatReportResponse,
	);
}
/* ************************END FETCH CollectionFormat DETAILS *************************** */

export function* collectionFormatReportSaga() {
	yield all([
		call(onFetchCollectionFormatReportDetails),
		call(onFetchCollectionFormatReportResponseReset),
	]);
}
